export default __webpack_public_path__ + "static/media/featureLeaves3x.81dc3a66.png";